// src/stages/stage1Plant/Rocks.jsx
import React, { useMemo } from "react";
import { useGLTF } from "@react-three/drei";

const LARGE_ROCK = "/stageAssets/stage1-plant/LargeRock.glb";

function RockInstance({
  scene,
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
}) {
  // traverse gltf for shadows
  const clonedScene = useMemo(() => {
  const clone = scene.clone(true);

  clone.traverse((obj) => {
    if (obj.isMesh) {
      obj.castShadow = true;
      obj.receiveShadow = true;
    }
  });

  return clone;
}, [scene]);

  return (
    <primitive
      object={clonedScene}
      position={position}
      rotation={rotation}
      scale={scale}
    />
  );
}

export default function Rocks() {
  const { scene: rockScene } = useGLTF(LARGE_ROCK);

  const rockData = [
  {
    id: "rock-01",
    position: [-6.5, -0.15, 7.5],
    rotation: [0, 0.35, 0],
    scale: 1.8,
  },
  {
    id: "rock-02",
    position: [-3.8, -0.1, 8.2],
    rotation: [0, -0.9, 0],
    scale: 1.35,
  },
  {
    id: "rock-03",
    position: [4.2, -0.2, 8.0],
    rotation: [0, 1.15, 0],
    scale: 1.6,
  },
  {
    id: "rock-04",
    position: [6.6, -0.15, 6.8],
    rotation: [0, -0.35, 0],
    scale: 1.25,
  },
  {
    id: "rock-05",
    position: [12, -0.2, -1.75],
    rotation: [0, 0, 0],
    scale: 1.25,
  },
  {
    id: "rock-06",
    position: [-5.75, -0.2, -9],
    rotation: [0, 1.5, 0],
    scale: 1.1,
  },
  {
    id: "rock-07",
    position: [-1, -0.2, -10],
    rotation: [0, 1.75, 0],
    scale: 0.85,
  },
];

  return (
    <group name="rocks">
      {rockData.map((rock) => (
        <RockInstance
          key={rock.id}
          scene={rockScene}
          position={rock.position}
          rotation={rock.rotation}
          scale={rock.scale}
        />
      ))}
    </group>
  );
}

useGLTF.preload(LARGE_ROCK);